import React, { useState } from 'react';
import { shootDayClientLink, shootDayCrewLink } from '../../utils/shootDayLinks';
const LINK_BUTTON = 'label-sm whitespace-nowrap text-paper/30 underline underline-offset-4 transition-colors duration-150 ease-out hover:text-paper/70 disabled:cursor-not-allowed disabled:opacity-40 disabled:no-underline';

/**
 * Copies the Shoot Day link for crew or client. Unlike CopyClientLink, the
 * token is already in hand by the time this renders — the builder loads the
 * whole shoot day record up front — so there is nothing to fetch here.
 */
function CopyLink({
  label,
  link
}: {
  label: string;
  link: string;
}) {
  const [state, setState] = useState<'idle' | 'done' | 'failed'>('idle');
  async function copy() {
    if (!link) {
      setState('failed');
      window.setTimeout(() => setState('idle'), 2200);
      return;
    }
    try {
      await navigator.clipboard.writeText(link);
    } catch {
      setState('failed');
      window.setTimeout(() => setState('idle'), 2200);
      return;
    }
    setState('done');
    window.setTimeout(() => setState('idle'), 1800);
  }
  return <button type="button" onClick={copy} disabled={!link} className={LINK_BUTTON} data-id="element-672" data-mp="6w2g0megsdwi">
      {state === 'done' ? `${label} copied ✓` : state === 'failed' ? 'Link unavailable' : `Copy ${label.toLowerCase()} link`}
    </button>;
}
export function CallSheetLinks({
  crewToken,
  clientToken,
  onDownloadPdf,
  downloadingPdf
}: {
  crewToken: string;
  clientToken: string;
  onDownloadPdf: () => void;
  downloadingPdf?: boolean;
}) {
  return <div className="mt-5 flex flex-wrap items-center gap-x-8 gap-y-3" data-id="element-673" data-mp="plsd5g5p9brl">
      <CopyLink label="Crew" link={shootDayCrewLink(crewToken)} data-id="element-674" data-mp="14i9o469z8odm" />
      <CopyLink label="Client" link={shootDayClientLink(clientToken)} data-id="element-675" data-mp="zkhkiezyzdtl" />
      <button type="button" onClick={onDownloadPdf} disabled={downloadingPdf} className={LINK_BUTTON} data-id="element-676" data-mp="zi53c421d7hl">
        {downloadingPdf ? 'Preparing PDF…' : 'Download PDF'}
      </button>
    </div>;
}